import { PerspectiveCamera, type PerspectiveCameraProps } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import { useRef } from 'react'
import * as THREE from 'three'

interface BrunoParallaxRigProps extends PerspectiveCameraProps {
  amplitude?: number
  friction?: number
}

export function ParallaxCamera({ amplitude = 0.5, friction = 5, ...props }: BrunoParallaxRigProps) {
  const groupRef = useRef<THREE.Group>(null!)

  useFrame((state, delta) => {
    if (!groupRef.current) return

    const targetX = state.pointer.x * amplitude
    const targetY = state.pointer.y * amplitude

    groupRef.current.position.x += (targetX - groupRef.current.position.x) * friction * delta
    groupRef.current.position.y += (targetY - groupRef.current.position.y) * friction * delta
  })

  return (
    <group ref={groupRef}>
      <PerspectiveCamera {...props} />
    </group>
  )
}
